import { render, staticRenderFns } from "./order-online.vue?vue&type=template&id=d2ae8b52&lang=pug&"
import script from "./order-online.vue?vue&type=script&lang=js&"
export * from "./order-online.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports